var render = function render(){var _vm=this,_c=_vm._self._c;return (this.item.uptime?.timeline.length > 0)?_c('div',[_c('span',[_vm._v(" "+_vm._s(this.item.uptime.percent + '%')+" ")]),_c('TimeProgressCard',{attrs:{"status":true,"info":this.item.uptime?.timeline,"period":this.translate('period'),"width":this.parent_width}})],1):_c('span',[_vm._v(" "+_vm._s(_vm.date)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }